import { render } from "./index.vue?vue&type=template&id=440a191f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "../style/buildingDevelopment.scss?vue&type=style&index=0&id=440a191f&lang=scss&scoped=true&external"
import "../style/common.scss?vue&type=style&index=1&id=440a191f&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-440a191f"]])

export default __exports__